export const headerData = {
  name: "Gaurav Shinde",
  title: "Hello! I am",
  desciption:
    "I believe that the best software is built with the user in mind. That's why I'm passionate about creating technology that not only solves complex problems but also enhances the human experience. ",
  image:
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnWYvEGsFR89XBFNdRUuT_O5Z1ZPXZJWtxfE76erYp&s",
  imagebw: "",
  resumePdf:
    "https://drive.google.com/file/d/1i11EJjzCiKjmsc3APEN3RnqnAE3y7Y5n/view?usp=drive_link",
};
